import { useCallback, useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Panel, SectionLabel } from "@/components/common/ui-kit";
import { Button } from "@/components/ui/button";
import { ItvRow, ItvEmpty } from "@/components/interventions/ItvRow";
import { InterventionDialog } from "@/components/interventions/InterventionDialog";

const GROUPS = [["Aperti", (i) => ["da_pianificare", "in_corso", "sospeso"].includes(i.status)], ["Pianificati", (i) => ["pianificato", "assegnato"].includes(i.status)],
  ["Completati", (i) => i.status === "completato"]];

export const CompanyInterventionsTab = ({ company }) => {
  const { can } = useAuth();
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(false);
  const load = useCallback(() => api.get("/interventions", { params: { company_id: company.id, sort: "created_at", limit: 100 } })
    .then((r) => setItems(r.data.items)).catch(() => setItems([])), [company.id]);
  useEffect(() => { load(); }, [load]);
  const critical = (items || []).filter((i) => ["a_rischio", "violato"].includes(i.sla_state) && !["completato", "annullato"].includes(i.status));
  return (
    <Panel className="p-5" data-testid="company-interventions-tab">
      <div className="mb-3 flex items-center justify-between">
        <SectionLabel>Interventi{critical.length ? ` · ${critical.length} SLA critici` : ""}</SectionLabel>
        {(can("interventions:create") || can("interventions:request")) && <Button size="sm" className="gap-1" onClick={() => setOpen(true)} data-testid="company-itv-new"><Plus className="h-4 w-4" />Richiedi intervento</Button>}
      </div>
      {items && !items.length && <ItvEmpty text="Nessun intervento per questo cliente." />}
      {GROUPS.map(([label, fn]) => {
        const list = (items || []).filter(fn);
        return list.length ? (
          <section key={label} className="mb-4" data-testid={`company-itv-group-${label.toLowerCase()}`}>
            <p className="mb-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-400">{label} · {list.length}</p>
            <ul className="divide-y divide-line">{list.map((i) => <ItvRow key={i.id} itv={i} />)}</ul>
          </section>
        ) : null;
      })}
      <InterventionDialog open={open} onOpenChange={setOpen} company={{ id: company.id, name: company.name }} onSaved={load} />
    </Panel>
  );
};
